import React from 'react';
import { H3 } from "../../styles/typography/typography.js";
import {
  SpanStyled,
} from './style.js';

import {
  TextWrapStyled,
} from '../Tabs-description/style.js';
import TabsCardEvents from "../TabsCardEvents/TabsCardEvents";
import GetCards from "../GetCards/GetCards";

//для компонента Grid — значение не менялось за всё время жизни компонента
const chooseCard = false;

const TabsEvent = ({ dashboard, manager, location, getSelections }) => (
  <>
    <SpanStyled>В рамках данного мероприятия состоится презентация активов ГПМ РТВ и пройдут показы следующих проектов каналов группы:</SpanStyled>
    <GetCards sourceCards={`selections/${getSelections}`} type="catalog" cardDisplayType="grid" tile={window.innerWidth > 767 ? dashboard : false} chooseCard={chooseCard} widthCard={"28%"} getSelections={getSelections} />
    {manager &&
      <>
        <TextWrapStyled>
          <H3>Менеджеры на данном мероприятии</H3>
          <TabsCardEvents manager={manager} location={location} />
        </TextWrapStyled>
      </>
    }
  </>
);

export default TabsEvent;
